import { StyleSheet } from 'react-native';
export default StyleSheet.create({
  formContainer: {
    marginTop: '2%',
    marginBottom: '2%',
    flex: 1,
  },

  button: {
    margin: 15,
    color: '#fff',
    padding: 10,
    paddingLeft: 30,
    paddingRight: 30,
    backgroundColor: '#69bbea'
  }
  ,
  container: {
    marginVertical: 8,
  },
  input: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 5,
    paddingVertical: 5,
    paddingLeft: 5,
    fontSize: 16,
    height: 40,
    color: '#c0cbd3',
  },
  label: {
    paddingVertical: 5,
    fontSize: 16,
    fontWeight: 'bold',
    color: '#c0cbd3',
  },
  textError: {
    color: '#f00',
    fontSize: 14,
  },

  item: {
    marginBottom: 14,
  },

  content: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#aaaaaa',
    justifyContent: 'space-around',
    alignItems: 'center',
    borderRadius: 30,

  },
  contentItem: {
    margin: 2,
    borderRadius: 30,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    width: 100,

  },
  contentItemActive: {
    backgroundColor: '#ffffff',
  },
  btnTab: {

  },

});
